import * as React from "react"
import { cn } from "../../lib/utils"
import { inputBaseClass } from "./input-styles"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Content rendered inside the field on the left, e.g. a currency symbol. */
  leading?: React.ReactNode
  /** Content rendered inside the field on the right, e.g. an icon button. */
  trailing?: React.ReactNode
  invalid?: boolean
  containerClassName?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, containerClassName, type, leading, trailing, invalid, ...props }, ref) => {
    const field = (
      <input
        type={type}
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(
          inputBaseClass,
          invalid && "border-danger/60 focus:border-danger focus:ring-danger/20",
          leading != null && "pl-8",
          trailing != null && "pr-10",
          className
        )}
        {...props}
      />
    )

    if (leading == null && trailing == null) return field

    return (
      <div className={cn("relative", containerClassName)}>
        {leading != null && (
          <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-fg-subtle">
            {leading}
          </span>
        )}
        {field}
        {trailing != null && (
          <span className="absolute inset-y-0 right-1.5 flex items-center">{trailing}</span>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
